<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
		className?: string;
		title?: string;
	}

	let { config, className = '', title = 'Frequently Asked Questions' }: Props = $props();
</script>

<div class="faq-section {className}">
	<h2>{title}</h2>
	<div class="faq-grid">
		{#if config.contactPage?.faq && config.contactPage.faq.length > 0}
			{#each config.contactPage.faq as faqItem}
				<div class="faq">
					<h3>{faqItem.question}</h3>
					<p>{faqItem.answer}</p>
				</div>
			{/each}
		{:else}
			<!-- Fallback FAQ if not configured -->
			<div class="faq">
				<h3>What is {config.productName}?</h3>
				<p>
					{config.productDescription} It's designed to help you achieve your goals
					through proven strategies and expert guidance.
				</p>
			</div>

			<div class="faq">
				<h3>How do I get started?</h3>
				<p>
					Simply <a href="/landing/" class="contact-link">sign up on our landing page</a>
					and you'll receive immediate access to {config.productName}.
				</p>
			</div>

			<div class="faq">
				<h3>Is there a community?</h3>
				<p>
					Yes! When you join {config.displayName}, you'll become part of a
					supportive community of like-minded individuals on similar journeys.
				</p>
			</div>

			<div class="faq">
				<h3>What if I need help?</h3>
				<p>
					We're here to support you every step of the way. Reach out to us at
					<a href="mailto:hello@{config.brand}" class="contact-link">
						hello@{config.brand}
					</a> and we'll be happy to help.
				</p>
			</div>
		{/if}
	</div>
</div>

<style>
	.faq-section {
		margin-bottom: 3rem;
	}

	.faq-section h2 {
		text-align: center;
		margin-bottom: 2rem;
		font-size: 1.75rem;
		color: var(--brand-primary);
	}

	.faq-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 1.5rem;
	}

	.faq {
		margin-bottom: 1.5rem;
		padding: 1rem;
		background: #f8fafc;
		border-radius: 8px;
	}

	.faq h3 {
		font-size: 1.25rem;
		color: var(--brand-primary);
		margin-bottom: 0.5rem;
	}

	.faq p {
		color: #374151;
		line-height: 1.7;
		margin-bottom: 1rem;
	}

	.contact-link {
		color: var(--brand-primary);
		text-decoration: none;
		font-weight: 600;
	}

	.contact-link:hover {
		color: var(--brand-secondary);
		text-decoration: underline;
	}

	@media (max-width: 768px) {
		.faq-grid {
			grid-template-columns: 1fr;
		}

		.faq-section h2 {
			font-size: 1.5rem;
		}
	}
</style>
